var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigiseqSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 108,
    viewBox: "0 0 95 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 0.200012C27.1 0.200012 27 0.200012 27 0.200012C12.1 0.200012 0 12.3 0 27.1C0 41.9 12.1 54 27 54C27.1 54 26.9 54 27 54V27.1H53.9V0.200012H27.2Z",
    fill: "#FF6400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9004 54.1V27.2C76.2004 27.2 94.3004 45.3 94.3004 67.6C94.3004 89.9 76.2004 108 53.9004 108H26.9004V54.1H53.9004Z",
    fill: "#C1CAD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiseqSmall);
export default __webpack_public_path__ + "static/media/digiseq-small.855158fbd8741309f49317feb3bdb9ce.svg";
export { ForwardRef as ReactComponent };